import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
export var generateWebsiteUrl = function generateWebsiteUrl(url) {
  if (!url) return "";
  try {
    var parsed = new _URL(url);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.href;
    }
    return "";
  } catch (_unused) {
    return "//".concat(url);
  }
};
export var capitalizeFirstLetter = function capitalizeFirstLetter(text) {
  var _text$charAt;
  return (text === null || text === void 0 || (_text$charAt = text.charAt(0)) === null || _text$charAt === void 0 ? void 0 : _text$charAt.toUpperCase()) + (text === null || text === void 0 ? void 0 : _sliceInstanceProperty(text).call(text, 1));
};
export var colorVariablesFormat = function colorVariablesFormat(primaryColor, secondaryColor) {
  return {
    "--primary-color": primaryColor,
    "--secondary-color": secondaryColor
  };
};

/**
 * Formats city, state, and postal code into a string.
 * Format: "city, state postalCode" - city and state separated by comma, state and postalCode by space
 *
 * @param city - City name
 * @param state - State abbreviation
 * @param postalCode - Postal/ZIP code
 * @param removeExtra4Digits - Whether to remove the extra 4 digits from ZIP+4 format (default: true)
 * @returns Formatted city/state/zip string
 */
export var formatCityStateZip = function formatCityStateZip(city, state, postalCode) {
  var removeExtra4Digits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cityTrimmed = (city === null || city === void 0 ? void 0 : _trimInstanceProperty(city).call(city)) || "";
  var stateTrimmed = (state === null || state === void 0 ? void 0 : _trimInstanceProperty(state).call(state)) || "";
  var postalCodeTrimmed = (postalCode === null || postalCode === void 0 ? void 0 : _trimInstanceProperty(postalCode).call(postalCode)) || "";

  // Remove the extra 4 digits from ZIP+4 format (e.g., "94107-1234" -> "94107")
  if (removeExtra4Digits && postalCodeTrimmed && _includesInstanceProperty(postalCodeTrimmed).call(postalCodeTrimmed, "-")) {
    postalCodeTrimmed = postalCodeTrimmed.split("-")[0];
  }
  var addr = "";
  if (cityTrimmed) {
    addr = cityTrimmed;
    if (stateTrimmed) {
      addr += ", ".concat(stateTrimmed);
    }
    if (postalCodeTrimmed) {
      addr += stateTrimmed ? " ".concat(postalCodeTrimmed) : ", ".concat(postalCodeTrimmed);
    }
  } else if (stateTrimmed) {
    addr = stateTrimmed;
    if (postalCodeTrimmed) {
      addr += " ".concat(postalCodeTrimmed);
    }
  } else if (postalCodeTrimmed) {
    addr = postalCodeTrimmed;
  }
  return addr;
};